﻿<script>
  import { onMount } from "svelte/internal";
  import { dispatchMountEvent, standardDocumentType } from "./services";
  import moment from "moment";
  import Icon from "./Icons.svelte";

  // props
  export let _emitMount;
  export let name;
  export let accept = standardDocumentType;
  export let maxsize;
  export let uploaded;
  export let readonly;
  export let deleteapi = "/api/requests/attachments";

  onMount(() => {
    if (_emitMount) {
      dispatchMountEvent();
    }
  });

  const isReadonly = readonly == true || readonly == "True";

  // local state
  let inputfiles = [];
  let previewFiles = [];
  let fileInput;
  let error = "";
  $: empty =
    (!uploaded || !uploaded.length) && (!inputfiles || !inputfiles.length);

  // events
  const inputChangeHandle = e => {
    error = "";
    
    for(const file of inputfiles) {
      // file extension
      if (!isValidFileType(file)) {
        // error
        error = "File type not supported";
        inputfiles = [];
        break;
      }
      // file size
      if (maxsize && file.size / 1024 / 1024 > maxsize) {
        // error
        error = "Maximum file size is " + maxsize + "mb";
        inputfiles = [];
        break;
      }
    };

    // add to preview list
    previewFiles = inputfiles;
  };
  // delete attachment
  const deleteAttachment = async id => {
    error = "";
    let isDeleted = false;
    try {
      // set state
      uploaded = uploaded.map(file =>
        file.id === id ? { ...file, deleting: true } : file
      );
      // featch
      let response = await fetch(`${deleteapi}/${id}`, {
        credentials: "same-origin",
        method: "DELETE"
      });
      if (response.status !== 200) {
        error = "Oops! Something went wrong!";
      } else {
        isDeleted = true;
      }
    } catch (err) {
      error = "Oops! Something went wrong!";
    }
    if (isDeleted) {
      uploaded = uploaded.filter(file => file.id !== id);
    } else {
      uploaded = uploaded.map(file =>
        file.id === id ? { ...file, deleting: false } : file
      );
    }
  };

  // clear recenct attachment
  const ClearRecentAttachmentHandle = () => {
    error = "";
    previewFiles = [];
    inputfiles = [];
    fileInput.files = null;
    fileInput.value = null;
  };
  function isValidFileType(file) {
    if (accept) {
      const regexString = accept
        .replace("*", ".*")
        .split(",")
        .join("|")
        .replace(/\s/g, "");

      if (
        new RegExp(regexString).test(file.type) ||
        new RegExp(regexString + "$", "i").test(file.name)
      ) {
        return true;
      }
      return false;
    }
    return true;
  }
  
  function getDownloadAllUrl(){
      let ids =  uploaded.map(x => "attachmentIds=" + x.id + "&").join('');
      return "/api/requests/attachments/download-all?" + ids;
  }
</script>

<div class="card card--edge">
  <div class="card-header">
    <h4 class="card-title">Attachments</h4>
  </div>
  <div class="card-body">
    <div class="table-responsive rounded border border-light">
      <table class="table table-striped table-flat">
        <thead>
          <tr>
            <th>Name</th>
            <th>Uploaded by</th>
            <th>Date Uploaded</th>
            <th class="table-col-xs" />
            <th />
          </tr>
        </thead>
        <tbody>
          {#if uploaded && uploaded.length}
            {#each uploaded as file, i}
              <tr>
                <td>
                  <a
                    href={file.downloadLink}
                    class="table-main-cell text-nowrap">
                    <Icon icon="Document" class="icon" />
                    <span>{file.name}</span>
                  </a>
                </td>
                <td>{file.uploadedBy}</td>
                <td>{moment(file.uploadedDate).format('DD/MM/YYYY')}</td>
                <td>
                  {#if !!file.canBeDeleted && !isReadonly}
                    <button
                      type="button"
                      class="btn btn-icon-danger border-0 {file.deleting ? 'is-loading' : ''}"
                      data-toggle="confirm"
                      data-type="delete"
                      data-message="Are you sure you want to delete this file?"
                      on:confirmed={e => {
                        deleteAttachment(file.id);
                      }}>
                      <Icon icon="Trash" class="icon icon-xs" />
                    </button>
                  {/if}
                </td>
                <td class="table-action-button">
                  <a
                    href={file.downloadLink}
                    class="btn btn-primary btn-square-sm">
                    <Icon icon="Download" class="icon icon-xs" />
                  </a>
                </td>
              </tr>
            {/each}
          {/if}
          {#each previewFiles as file, i}
            <tr>
              <td>
                <div class="table-main-cell text-nowrap">
                  <Icon icon="Document" class="icon text-muted" />
                  <span>{file.name}</span>
                </div>
              </td>
              <td class="text-muted">-</td>
              <td class="text-muted">-</td>
              <td colspan="2" class="text-muted">
                <div class="btn-icon-end ml-2">
                  <Icon icon="Pending" class="icon icon-xs" />
                  <span class="font-italic">Pending</span>
                </div>
              </td>
            </tr>
          {/each}
          {#if empty}
            <tr>
              <td colspan="100" class="text-center">
                <div class="font-italic">No attachments yet</div>
              </td>
            </tr>
          {/if}
        </tbody>
      </table>
    </div>
    {#if !isReadonly}
      <div class="pt-4 pb-2" />
      <input
        type="file"
        id={name}
        {name}
        multiple
        class="form-control-hidden"
        bind:files={inputfiles}
        bind:this={fileInput}
        on:change={inputChangeHandle}
        {accept} />
      {#if error.length}
        <div class="alert alert-danger" role="alert">
          <div class="row no-gutters">
            <div class="col-auto">
              <Icon icon="XCircle" class="icon alert-icon" />
            </div>
            <div class="col">
              <h6 class="mb-0">{error}</h6>
            </div>
          </div>
        </div>
      {/if}

      <div class="row half-gutters row-vertical-gutters align-items-center">
        <div class="col-sm-auto">
          <label
            class="btn btn-primary mb-0 btn-icon-start"
            for={name}>
            <Icon icon="Browse" class="icon icon-sm" />
            Attach Files(s)
          </label>
        </div>
        <div class="col-auto mr-auto">
          <span class="text-muted font-italic">(max. upload {maxsize}mb)</span>
        </div>
        {#if previewFiles.length}
          <div class="col-auto">
            <a
              href="#"
              class="text-decoration-underline text-muted link-hover-danger
              medium btn-icon-start"
              on:click|preventDefault={ClearRecentAttachmentHandle}>
              <Icon icon="Trash" class="icon icon-sm" />
              Remove pending attachment(s)
            </a>
          </div>
        {:else if !previewFiles.length && uploaded.length}
            <div class="col-auto">
                <a href={getDownloadAllUrl()} class="btn btn-primary btn-square-sm">
                    <span class="mx-2">Download all</span>
                </a>
            </div>
        {/if}
      </div>
      <div class="pt-1" />
    {:else if !previewFiles.length && uploaded.length}
        <div class="pt-4 pb-2"></div>
        <div class="d-flex justify-content-end">
            <a href={getDownloadAllUrl()} class="btn btn-primary btn-square-sm">
                <span class="mx-2">Download all</span>
            </a>
        </div>
    {/if}
  </div>
</div>
